import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { PointSource, RoundingMode } from '../models/points-multiplier.model';

export const NameChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: Name Changed',
  props<{ recipeDisplayName: string }>(),
);

export const SchemaChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: Schema Changed',
  props<{ selectedSchema: string }>(),
);

export const PointSourceChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: Point Source Changed',
  props<{ selectedPointSourceId: number }>(),
);

export const RemarkChanged = createAction(
  '[Recipes - Points Multiplier Points Create/Update]: Remark Changed',
  props<{ selectedRemark: string }>(),
);

export const PointExpirationTypeChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: Point Expiration Type Changed',
  props<{ pointExpirationType: string }>(),
);

export const PointExpirationValueChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: Point Expiration Value Changed',
  props<{ pointExpirationValue: any }>(),
);

export const PointMultiplierChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: PointMultiplier Changed',
  props<{ selectedPointMultiplier: number }>(),
);

export const RoundingModeChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: Rounding Mode Changed',
  props<{ roundingMode: RoundingMode }>(),
);

export const StartDateChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: StartDate Changed',
  props<{ startDate: string }>(),
);

export const StartDateCleared = createAction('[Recipes - Points Multiplier Create/Update]: StartDate Cleared');

export const EndDateChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: EndDateChanged Changed',
  props<{ endDate: string }>(),
);

export const EndDateCleared = createAction('[Recipes - Points Multiplier Create/Update]: EndDateChanged Cleared');

export const InactiveChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: Inactive Changed',
  props<{ inactive: boolean }>(),
);

export const DescriptionChanged = createAction(
  '[Recipes - Points Multiplier Create/Update]: Description Changed',
  props<{ description: string }>(),
);

export const UpdateRecipePM = createAction('[Recipes - Points Multiplier Create/Update]: Update Recipe');
export const UpdateRecipeSuccessPM = createAction(
  '[Recipes - Points Multiplier Create/Update]: Update Recipe Success',
  props<{ response: any }>(),
);
export const UpdateRecipeFail = createAction(
  '[Recipes - Points Multiplier Create/Update]: Update Recipe Fail',
  props<{ error: HttpErrorResponse }>(),
);

export const CreateRecipePM = createAction('[Recipes - Points Multiplier Create/Update]: Create Recipe');
export const CreateRecipeSuccessPM = createAction(
  '[Recipes - Points Multiplier Create/Update]: Create Recipe Success',
  props<{ response: any }>(),
);
export const CreateRecipeFail = createAction(
  '[Recipes - Points Multiplier Create/Update]: Create Recipe Fail',
  props<{ error: HttpErrorResponse }>(),
);

export const SubmitDataPM = createAction('[Recipes - Points Multiplier Create/Update]: Submit Data');

export const PointSourcesInit = createAction('[Recipes - Points Multiplier Create/Update]: Point Sources Init');

export const PointSourcesSuccess = createAction(
  '[Recipes - Points Multiplier Create/Update]: Point Sources Success',
  props<{ pointSources: PointSource[] }>(),
);
export const PontSourcesFailure = createAction(
  '[Recipes - Points Multiplier Create/Update]: Point Sources Failed',
  props<{ error: HttpErrorResponse }>(),
);
